import { type RadarPredictions } from '@sg/garnish';

import { type LocationSearchMachineEvents } from '../../LocationSearch.types';
import { getRadarPredictionId } from '../../utils';

// ─────────────────────────────────────────────────────────────────────────────

export async function selectPrediction(params: SelectPredictionParams) {
  const { predictions, event } = params;
  const { predictionId } = event;

  const selectedPrediction = predictions.find(
    (prediction) => getRadarPredictionId(prediction) === predictionId,
  );

  if (!selectedPrediction) return;

  const { formattedAddress, latitude, longitude, layer } = selectedPrediction;

  const types: readonly string[] = layer ? layer.split(',') : [];

  return {
    description: formattedAddress,
    lat: latitude,
    lng: longitude,
    types,
  };
}

// ─── Types ───────────────────────────────────────────────────────────────────

type SelectPredictionParams = {
  predictions: RadarPredictions;
  event: SelectPredictionEvent;
};

type SelectPredictionEvent = Extract<LocationSearchMachineEvents, { type: 'SELECT_PREDICTION' }>;
